var tabSwitch = (context, selector) => {
	const sizeGuideTabs = document.querySelectorAll('.size-guide-tab');
	const sizeGuides = document.querySelectorAll('.size-guide-container');
	if (context == 'tab') {
		for (let i = 0; i < sizeGuides.length; i++) {
			const sizeGuide = sizeGuides[i];
			if (parseInt(sizeGuide.getAttribute('data-id')) == selector) {
				sizeGuide.style.display = "block";
			} else {
				sizeGuide.style.display = "none";
			}
		}
	}
	if (context == 'brand') {
		var brandFirstTab = '';
		for (let i = 0; i < sizeGuideTabs.length; i++) {
			const tab = sizeGuideTabs[i];
			if (tab.getAttribute('data-brand') == selector) {
				tab.style.display = "block";
				if (brandFirstTab == '') {
					var brandFirstTab = parseInt(tab.querySelector('input').id);
					tab.querySelector('input').checked = true;
					tabSwitch('tab', brandFirstTab);
				}
			} else {
				tab.style.display = "none";
				tab.querySelector('input').checked = false;
			}
		}
	}
  if (context == 'units') {
    const sizeGuideContainer = selector.closest('.size-guide-container'),
          checked = selector.checked;
    // console.log(sizeGuideContainer);
    if (checked == true) {
      // cm
      sizeGuideContainer.querySelector('[data-unit="cm"]').style.display = "block";
      sizeGuideContainer.querySelector('[data-unit="in"]').style.display = "none";
    } else if (checked == false) {
      // in
      sizeGuideContainer.querySelector('[data-unit="in"]').style.display = "block";
      sizeGuideContainer.querySelector('[data-unit="cm"]').style.display = "none";
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
	const firstBrand = document.querySelector('.brand-switcher').getAttribute('data-brand');
	tabSwitch('brand', firstBrand);
	tabSwitch('tab', 1);
});

document.addEventListener('shopify:section:load', function () {
	const firstBrand = document.querySelector('.brand-switcher').getAttribute('data-brand');
	tabSwitch('brand', firstBrand);
	tabSwitch('tab', 1);
});